import { render, staticRenderFns } from "./criterion.vue?vue&type=template&id=908b812e&scoped=true&"
import script from "./criterion.vue?vue&type=script&lang=js&"
export * from "./criterion.vue?vue&type=script&lang=js&"
import style0 from "./criterion.vue?vue&type=style&index=0&id=908b812e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908b812e",
  null
  
)

export default component.exports